import { render } from "./dropmenu.vue?vue&type=template&id=15e014e7"
import script from "./dropmenu.vue?vue&type=script&lang=js"
export * from "./dropmenu.vue?vue&type=script&lang=js"
script.render = render

export default script